export const CLASS_NAMES = {
  wrapper: 'flex flex-col md:px-28 md:py-10',
};

export const INPUT_PROPS = {
  name: 'email',
  label: 'Email of the user to login as',
  wrapperProps: {
    className: 'mt-2',
  },
};
